import React, { useEffect, useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import { Dialog, Link, Popover, Typography } from "@mui/material";
import "./PopupCalendar.css";
import DialogHeader from "@mostrans/web-components/components/base/Dialog/DialogHeader";
import DialogContent from "@mostrans/web-components/components/base/Dialog/DialogContent";
import moment from "moment";

export default function PopupCalendar({
  open,
  anchorEl,
  onClose,
  jobTitle,
  dataCandidates,
}) {
  const calendarRef = useRef();
  const [selectedEvent, setSelectedEvent] = useState();
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (calendarRef.current) {
      setTimeout(() => {
        calendarRef.current.calendar.updateSize();
      }, 100);
    }
  }, []);

  const handleEventClick = (ev) => {
    setSelectedEvent(ev.event);
    setModalOpen(true);
  };

  const handleEventClose = () => {
    setSelectedEvent(null);
    setModalOpen(false);
  };

  const unfilteredEvents = dataCandidates.map((event) => {
    if (event?.status_hr_id === 3) {
      return {
        title: "Psikotest",
        allDay: false,
        start: moment(event?.CandidateDetail?.psikotest_date).format(),
        invitationDate: moment(event?.created_date).format(),
        candidateName: event?.CandidateDetail?.full_name,
        linkPsikotest: event?.CandidateDetail?.link_meet_psikotest,
      };
    }
    if (event?.status_hr_id === 4) {
      return {
        title: "HR Interview",
        allDay: false,
        start: moment(event?.CandidateDetail?.interview_hr_date).format(),
        invitationDate: moment(event?.created_date).format(),
        candidateName: event?.CandidateDetail?.full_name,
        linkMeetingInterview: event?.CandidateDetail?.link_meet_interview,
      };
    }
    if (event?.status_hr_id === 5) {
      return {
        title: "User Interview",
        allDay: false,
        start: moment(event?.CandidateDetail?.interview_user_date).format(),
        invitationDate: moment(event?.created_date).format(),
        candidateName: event?.CandidateDetail?.full_name,
      };
    }
    if (event?.status_hr_id === 6) {
      return {
        title: "Technical Test Due Date",
        allDay: false,
        start: moment(event?.CandidateDetail?.technical_test_due_date).format(),
        invitationDate: moment(event?.created_date).format(),
        candidateName: event?.CandidateDetail?.full_name,
      };
    }
    if (event?.status_hr_id === 8) {
      return {
        title: "Medical Check Up",
        allDay: false,
        start: moment(event?.CandidateDetail?.medical_checkup_date).format(),
        invitationDate: moment(event?.created_date).format(),
        candidateName: event?.CandidateDetail?.full_name,
      };
    }
  });

  const events = unfilteredEvents.filter((element) => element !== undefined);

  const handleEventDidMount = (info) => {
    if (info.view.type === "listWeek") {
      info.el.querySelector(".fc-list-event-title").textContent =
        info.event.title + " (" + jobTitle + ") - " + info.event.extendedProps.candidateName;
    }
  };

  return (
    <>
      <Dialog open={open} maxWidth onClose={onClose}>
        <div style={{ margin: "1rem", width: "55vw" }}>
          <FullCalendar
            plugins={[
              dayGridPlugin,
              timeGridPlugin,
              listPlugin,
              interactionPlugin,
            ]}
            ref={calendarRef}
            height="80vh"
            events={events}
            eventDidMount={handleEventDidMount}
            eventColor="#0A8C4A"
            eventClassNames={(arg) =>
              arg.event.allDay ? "all-day" : "not-all-day"
            }
            eventClick={handleEventClick}
            eventTimeFormat={{
              hour: "2-digit",
              minute: "2-digit",
              meridiem: false,
              hour12: false,
            }}
            dayMaxEventRows={true}
            initialView="dayGridMonth"
            headerToolbar={{
              start: "today prev,next",
              center: "title",
              end: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
            }}
            buttonText={{
              today: "Today",
              month: "Month",
              week: "Week",
              day: "Day",
              list: "List",
            }}
          />
        </div>
      </Dialog>

      <Dialog fullWidth open={modalOpen} onClose={handleEventClose}>
        <DialogHeader
          bgColor="var(--color-white)"
          onClose={handleEventClose}
          showCloseButton={true}
        >
          <h5>{selectedEvent?.title}</h5>
        </DialogHeader>
        <DialogContent>
          Tanggal {selectedEvent?.title}:{" "}
          <h6 style={{ marginBottom: ".5rem" }}>
            {selectedEvent?.startStr
              ? moment(selectedEvent?.startStr).format(
                  "dddd, DD MMMM yyyy HH:mm"
                )
              : "-"}
          </h6>
          Tanggal Invitation:{" "}
          <h6>
            {selectedEvent?.extendedProps?.invitationDate
              ? moment(selectedEvent?.extendedProps?.invitationDate).format(
                  "dddd, DD MMMM yyyy HH:mm"
                )
              : "-"}
          </h6>
          <br />
          <h6 style={{ fontWeight: 400 }}>Nama Kandidat:</h6>
          <Typography variant="h5" sx={{ fontWeight: 500 }}>
            {selectedEvent?.extendedProps?.candidateName}
          </Typography>
          {selectedEvent?.extendedProps?.linkPsikotest && (
            <>
              <br />
              <h6 style={{ fontWeight: 400 }}>
                Link Meeting {selectedEvent?.title}:
              </h6>
              <Link
                href={selectedEvent?.extendedProps?.linkPsikotest}
                underline="hover"
              >
                {selectedEvent?.extendedProps?.linkPsikotest}
              </Link>
            </>
          )}
          {selectedEvent?.extendedProps?.linkMeetingInterview && (
            <>
              <br />
              <h6 style={{ fontWeight: 400 }}>
                Link Meeting {selectedEvent?.title}:
              </h6>
              <Link
                href={selectedEvent?.extendedProps?.linkMeetingInterview}
                underline="hover"
              >
                {selectedEvent?.extendedProps?.linkMeetingInterview}
              </Link>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
